import React from 'react';
import {
  ArrowLeftRight,
  BriefcaseBusiness,
  Building,
  ChartBarStacked,
  ChartNoAxesCombined,
  CircleDollarSign,
  CreditCard,
  ExternalLink,
  File,
  FileSpreadsheet,
  HandCoins,
  LayoutDashboard,
  QrCode,
  Scale,
  SquareArrowDown,
  Store,
  Table,
  Wallet,
  House,
  ChartColumnIncreasing,
  Users,
  type LucideProps,
} from 'lucide-react';

const VirtualAccountIcon = React.forwardRef<SVGSVGElement, LucideProps>(({ ...props }, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 20}
    height={props.height ?? 20}
    viewBox="0 0 30 20"
    {...props}
  >
    <rect
      x="0.5"
      y="0.5"
      width="28"
      height="19"
      rx="1"
      ry="1"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
    />
    <rect x="0.5" y="3" width="28" height="2" fill="currentColor" />
    <text
      x="8"
      y="15"
      fill="currentColor"
      fontFamily="Arial, sans-serif"
      fontSize="10"
      fontWeight="bold"
    >
      VA
    </text>
  </svg>
));

const APIIcon = React.forwardRef<SVGSVGElement, LucideProps>(({ ...props }, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 24}
    height={props.height ?? 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4 13h5"></path>
    <path d="M12 16v-8h3a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-3"></path>
    <path d="M20 8v8"></path>
    <path d="M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5"></path>
  </svg>
));

VirtualAccountIcon.displayName = 'VirtualAccountIcon';
APIIcon.displayName = 'APIIcon';

type IconType = {
  name: string;
  icon: React.ComponentType<LucideProps>;
};

const IconMenu: IconType[] = [
  { name: 'Home', icon: House },
  { name: 'Reports', icon: ChartColumnIncreasing },
  { name: 'Invoices', icon: File },
  { name: 'Accounts', icon: Users },
];

const IconSide: IconType[] = [
  { name: 'Dashboard', icon: LayoutDashboard },
  { name: 'Account Group', icon: Building },
  { name: 'Analytics', icon: ChartNoAxesCombined },
  { name: 'Balance', icon: Scale },
  { name: 'Cash Flow', icon: BriefcaseBusiness },
  { name: 'Transaction', icon: ArrowLeftRight },
  { name: 'Qris Payment', icon: QrCode },
  { name: 'Settlement', icon: File },
  { name: 'Logs', icon: Table },
  { name: 'Deposit VA', icon: CircleDollarSign },
  { name: 'Payment Link', icon: ExternalLink },
  { name: 'Debit Card', icon: ChartBarStacked },
  {
    name: 'Virtual Account',
    icon: VirtualAccountIcon,
  },
  { name: 'Merchant', icon: Store },
  { name: 'Mode', icon: Store },
  { name: 'Withdrawal', icon: SquareArrowDown },
  { name: 'Ewallet', icon: Wallet },
  { name: 'Disbursement', icon: HandCoins },
  { name: 'Credit Card', icon: CreditCard },
  { name: 'Portal Download', icon: FileSpreadsheet },
];

export { APIIcon, IconSide, IconMenu };
